<template>
  <div class="page">
    <div class="page-content">
     
      <!-- 交易表单 -->
      
        <el-form
          :model="mppMoneyPay"
          ref="blockTradeForm"
          :rules="rules"
          label-width="120px"
          size="small"
        >
          <!-- 用户选择 -->
          <el-form-item  label="用户" prop="userId" >
            <GridSelectU style="width: 177px;" labelName="userName"
                labelValue="id" title="选择用户" :value="mppMoneyPay.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="mppMoneyPayState == 'check'"
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          
          <!-- 门店选择 -->
          <el-form-item label="门店" prop="storeId">
            <GridSelectLi style="width: 177px" title="选择门店" labelName="storeName" labelValue="id" :value="mppMoneyPay.storeId" :disabled="mppMoneyPayState == 'check'"
                :limit="1" size="small" placeholder="请选择门店" @getValue="getValueStoreId" :columns="STORE_code" :searchs="STORE_search"
                dataListUrl="/shop/store/findList" entityBeanName="shopStore" queryEntityUrl="/shop/store/get" >
            </GridSelectLi>
          </el-form-item>
          
          <!-- 让利比例 -->
          <el-form-item label="让利比例" prop="serviceRatio">
            <el-select
                v-model="mppMoneyPay.serviceRatio"
                @change="onServiceRatioChange"
                placeholder="请选择让利比例"
                size="small"
                style="width: 200px"
            >
              <el-option :label="item.value" :value="item.key" v-for="(item, index) in serviceRatioList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          
          <!-- 交易金额（自动计算） -->
          <el-form-item label="交易金额" prop="money">
            <el-input 
              style="width: 300px;"
              v-model="mppMoneyPay.money" 
              placeholder="自动计算" 
              :disabled="true"
            ></el-input>
          </el-form-item>

          <!-- 让利金额 -->
          <el-form-item label="让利金额" prop="payMoney">
            <el-input 
              style="width: 300px;"
              v-model="mppMoneyPay.payMoney" 
              placeholder="请输入让利金额" 
              :disabled="blockTradeState == 'check'"
              @input="calculateTradeMoney"
            ></el-input>
          </el-form-item>

          <el-form-item label="大额订单类型">
					    <el-select size="small" clearable v-model="mppMoneyPay.blockTradeType" placeholder="请选择" style="width: 200px">
					        <el-option label="特殊" :value="1"> </el-option>
					        <el-option label="正常" :value="0"> </el-option>
					    </el-select>
					</el-form-item>
          
        </el-form>
        
        <div slot="footer" class="button">
          <el-button
            type="primary"
            @click="submitForm"
            v-if="blockTradeState === 'add'"
          >确定</el-button>
        </div>
      
    </div>
  </div>
</template>

<script>
import { get, post } from '@/utils/request.js';
import { USER, USER_SEARCH, STORE, STORE_SEARCH } from '@/utils/constant';
import GridSelectU from '@/components/gridselect/index.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
export default {
  name: 'BlockTrade',
  components: {
    GridSelectU,
    GridSelectLi
  },
  data() {
    return {
      showDialog: false,
      blockTradeState: 'add', // add, check
      USER_code: USER,
      USER_search: USER_SEARCH,
      STORE_code: STORE,
      STORE_search: STORE_SEARCH,
      loading: false,
      selectedUser: null,
      selectedStore: null,
      mppMoneyPay: {
        payMoney: '', //支付金额
        storeId: '', //门店ID
        userId: '', //用户ID
        serviceRatio: '0.20', //服务费率，默认选择0.20
        serviceType: '4', //服务类型，默认选择4
        blockTradeType: '',  // 大额订单类型 用于区分大额订单奖励
        money: '' //交易金额

      },
      serviceRatioList: [
        {key: '0', value: '0.038'},
        {key: '1', value: '0.05'},
        {key: '2', value: '0.10'},
        {key: '3', value: '0.15'},
        {key: '4', value: '0.20'}
      ],
    };
  },
  methods: {

    // 处理用户选择
    getValueUser(value){
        this.mppMoneyPay.userId = value
    },
    
    // 处理门店选择
    getValueStoreId(value){
      this.mppMoneyPay.storeId = value
    },
    
    // 处理让利比例选择变化
    onServiceRatioChange(key) {
      // 查找选中的选项
      const selectedItem = this.serviceRatioList.find(item => item.key === key);
      if (selectedItem) {
        this.mppMoneyPay.serviceType = key;
        this.mppMoneyPay.serviceRatio = selectedItem.value;
        // 重新计算交易金额
        this.calculateTradeMoney();
      }
    },
    
    // 根据让利金额和让利比例计算交易金额
    calculateTradeMoney() {
      const discountMoney = parseFloat(this.mppMoneyPay.payMoney);
      const serviceRatio = parseFloat(this.mppMoneyPay.serviceRatio);
      
      if (!isNaN(discountMoney) && !isNaN(serviceRatio) && serviceRatio > 0) {
        // 交易金额 = 让利金额 / 让利比例
        this.mppMoneyPay.money = (discountMoney / serviceRatio).toFixed(2);
      } else {
        this.mppMoneyPay.money = '';
      }
    },
    
    // 查询用户详情
    searchUserDetail(userId) {
      this.loading = true;
      get('/mpp/user/get', { id: userId }).then((res) => {
        this.loading = false;
        if (res.success && res.data) {
          // 可以在这里保存用户详情信息，用于显示
          this.selectedUser = res.data;
        } else {
          this.$message.error('查询用户详情失败');
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('查询用户详情失败');
      });
    },
    
    // 查询门店详情
    searchStoreDetail(storeId) {
      this.loading = true;
      get('/shop/store/get', { id: storeId }).then((res) => {
        this.loading = false;
        if (res.success && res.data) {
          // 可以在这里保存门店详情信息，用于显示
          this.selectedStore = res.data;
        } else {
          this.$message.error('查询门店详情失败');
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error('查询门店详情失败');
      });
    },
    
    // 提交表单
    submitForm() {

          console.log("提交表单", this.mppMoneyPay)
          // 这里是示例的API调用，实际使用时需要替换为正确的API
          post('/shop/app/storepayorder/blockTrade', { ...this.mppMoneyPay }).then((res) => {
            this.loading = false;
            if (res.success) {
              this.$message.success('交易创建成功');
              this.mppMoneyPay = {};
              // 可以在这里添加刷新列表等操作
            } else {
              this.$message.error(res.msg || '交易创建失败');
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error('交易创建失败');
          });
        
    }
  }
};
</script>

<style scoped>
.page {
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
  background: #f5f7fa;
}

.page-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  height: calc(100% - 40px);
  overflow: auto;
}

.page-tool-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.el-btn-group {
  display: flex;
  align-items: center;
}

.button {
  margin-left: 300px;
}


/* 可以根据需要添加更多样式 */
</style>